import { interfaces } from 'inversify'
import { Ref } from 'vue'

import { ActiveParticipant } from './ActiveParticipant'

type SI<T> = interfaces.ServiceIdentifier<T>

interface VolleyballRelationIoCBindingsInterface {
  ActiveParticipant: SI<Ref<ActiveParticipant>>
}

export const VolleyballRelationIoCBindings: VolleyballRelationIoCBindingsInterface =
  { ActiveParticipant: Symbol('ActiveParticipant') }
